<template>
    <div class="nav-content-wrapper" v-if="!$store.state.waitingRequest">
        <admin-navbar />
        
        <div class="content">
            <h2>Modifier des comptes utilisateurs</h2>

            <table>
                <tr>
                    <th>Identifiant</th>
                    <th>Adresse e-mail</th>
                    <th>Dernière connexion</th>
                    <th>Date de création</th>
                    <th>Commentaires postés</th>
                    <th>Rôle</th>
                    <th>Modifier</th>
                    <th>Supprimer</th>
                </tr>
                <tr v-for="account in accounts" :key="account.id">
                    <td>{{ account.identifiant }}</td>
                    <td>{{ account.mail }}</td>
                    <td>{{ account.derniere_connexion }}</td>
                    <td>{{ account.created_at }}</td>
                    <td>{{ account.comments_count }}</td>
                    <td>{{ frRole(account.role) }}</td>
                    <td><router-link :to="'editAccount/'+account.id"><i class="fas fa-edit"></i></router-link></td>
                    <td><a href="#" v-if="account.role != 1" @click.prevent="deleteAccount(account, 'confirm')"><i class="fas fa-times-circle"></i></a></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import Session from '../mixins/adminSession';
    import AdminNavbar from '../views/AdminNavbar';

    export default {
        name: "AdminEditAccounts",
        mixins: [Session],
        components: {
            'admin-navbar': AdminNavbar
        },
        data() {
            return {
                accounts: []
            }
        },
        mounted() {
            this.getAllAccounts();
        },
        methods: {
            getAllAccounts() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({post: "1"}));
                
                axios
                .post(this.$store.state.apiUrl+"?request=getAllAccounts", formData)
                .then((response) => {
                        console.log(response.data);
                    if(response.data.length > 0) {
                        this.accounts = response.data;
                    }
                });
            },
            deleteCommentsAccount(account) {
                let formData = new FormData();
                formData.append('data', JSON.stringify({ post: "1", accountId: account.id }));
                
                axios.post(this.$store.state.apiUrl+"?request=deleteCommentsAccount", formData)
                .then((response) => {
                    if(response.data) {
                        this.deleteAccount(account, 'delete');
                    }
                });
            },
            deleteAccount(account, action) {
                if(action == 'confirm') {
                    action = confirm('Souhaitez-vous vraiment supprimer le compte "'+ account.identifiant +'" ?');
                } else {
                    action = true;
                }

                if (action) {
                    let formData = new FormData();
                    formData.append('data', JSON.stringify({ post: "1", accountId: account.id }));
                    
                    axios
                    .post(this.$store.state.apiUrl+"?request=deleteAccount", formData)
                    .then((response) => {
                        if(response.data == true) {
                            alert('Le compte a bien été supprimé');
                            this.getAllAccounts();
                        }
                        else if(response.data == 'comments') {
                            this.deleteCommentsAccount(account);
                        }
                        else {
                            alert("Le compte n'a pas été supprimé");
                        }
                    });
                }
            },
            frRole(accountRole) {
                let role = '';

                switch(accountRole) {
                    case '0' :
                        role = 'Membre';
                        break;
                    case '1' :
                        role = 'Administrateur';
                        break;
                    case '2' :
                        role = 'Modérateur';
                        break;
                    case '3' :
                        role = 'Game manager';
                        break;
                }

                return role;
            }
        }
    }
</script>

<style scoped src="@/assets/admin.css">
</style>
